export default "__VITE_ASSET__DEnnfAVu__"